module.exports = __webpack_public_path__ + "img/customer06.1ae59859.jpg";